import { render } from "./TripleChoice.vue?vue&type=template&id=4ad336f6"
import script from "./TripleChoice.vue?vue&type=script&lang=js"
export * from "./TripleChoice.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__